import { RouteProp, useNavigation, useRoute } from '@react-navigation/core';
import { StackNavigationProp } from '@react-navigation/stack';
import React, { useEffect } from 'react';
import { Platform } from 'react-native';
import styled from 'styled-components/native';

import Button from '../../components/Button';
import HtmlWebView from '../../components/HtmlWebView';
import Spacer from '../../components/Spacer';
import Colors from '../../constants/Colors';
import { StudiesParamList } from '../../navigation/StudiesNavigator';
import { showMyStudies } from './helpers/ParticipantStatusChangeHelpers';

const StyledContainer = styled.ScrollView.attrs(() => ({
  contentContainerStyle: {
    flexGrow: 1,
    paddingHorizontal: 16,
    paddingBottom: 24
  }
}))`
  flex: 1;
  background-color: ${Colors.background};
`;

const StyledMessageView = styled.View`
  flex: 1;
  width: 100%;
  max-width: 475px;
  align-self: center;
  padding-top: 24px;
`;

const StyledButtonContainer = styled.View`
  width: 100%;
  max-width: 475px;
  align-self: center;
`;

const ScreenFailedMessageScreen: React.FC = () => {
  const navigation = useNavigation<StackNavigationProp<any>>();
  const route = useRoute<RouteProp<StudiesParamList, 'ScreenFailedMessage'>>();
  const message = route.params?.message ?? '';

  useEffect(() => {
    const unsubscribe = navigation.addListener('beforeRemove', e => {
      const action = e.data.action;
      if (action.type === 'GO_BACK' || action.type === 'POP') {
        e.preventDefault();
        showMyStudies(navigation);
      }
    });
    return unsubscribe;
  }, [navigation]);

  useEffect(() => {
    if (Platform.OS !== 'web') return;
    const onPopState = () => {
      showMyStudies(navigation);
    };
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, [navigation]);

  return (
    <StyledContainer>
      <StyledMessageView>
        <HtmlWebView bodyColor={Colors.darkText} html={message} />
      </StyledMessageView>
      <Spacer size={4} />
      <StyledButtonContainer>
        <Button onPress={() => showMyStudies(navigation)}>Close</Button>
      </StyledButtonContainer>
    </StyledContainer>
  );
};

export default ScreenFailedMessageScreen;
